<script>
import GuestDocumentationMixin from '@/mixins/guestdocumentation'
import { helpers } from '@/helpers.js'

export default {
  name: 'GuestDocumentationCostsaver',
  mixins: [ GuestDocumentationMixin ],
  computed: {},
  data () {
    return {
      isModalTermsAndConditionsToggle: false
    }
  },
  methods: {
    isInvalidContent (field = '') {
      return helpers.isInvalidContent(field)
    },
    toggleTermsAndConditionsModal () {
      this.isModalTermsAndConditionsToggle = !this.isModalTermsAndConditionsToggle
      document.body.classList.toggle('modal-open', this.isModalTermsAndConditionsToggle)
    },
    printPage () {
      window.print()
    }
  }
}
</script>

<style lang="scss" scoped>
// @import './font-effra.scss';
@import './font-fontawesome.scss';
@import './bootstrap.scss';
@import './main.scss';
@import './style-1.scss';
@import './print.scss';
</style>
<template>
  <div id="menu" class="body-page fp-viewing-home body" :class="{ 'modal-open': isModalToggle }">
    <!-- BEGIN OF site header Menu -->
    <header class="cover navbar page-header-drawer menu-right logo-left topmenu-right">
      <!-- START cover -->
      <div class="cover-tittle">
        <div class="cover-logo">
          <a class="navbar-brand" href="#">
            <span class="logo">
              <img class="light-logo gg" src="/guestdocumentation/costsaver/img/logo.png" alt="Logo">
            </span>
          </a>
        </div>
      </div>
    </header>
    <!-- END OF site header Menu-->

    <!-- BEGIN OF site header Menu -->
    <header class="page-header navbar page-header-drawer menu-right logo-left topmenu-right">

      <!-- Begin of menu icon toggler -->
      <button class="navbar-toggler site-menu-icon" id="navMenuIcon" :class="{ 'menu-visible': isMenuToggle }" @click="toggleMenu">
        <span class="menu-icon menu-icon-line" :class="{ 'menu-visible': isMenuToggle }">
          <span class="text show-menu-visible" :class="{ 'menu-visible': isMenuToggle }">Close</span>
          <span class="text hide-menu-visible" :class="{ 'menu-visible': isMenuToggle }">Menu</span>
          <span class="bars">
            <span class="bar1"></span>
            <span class="bar2"></span>
            <span class="bar3"></span>
          </span>
        </span>
      </button>

      <div class="cover-tittle  animated delay-1s slow fadeIn">
        <div class="cover-logo">
          <a class="navbar-brand" href="#">
            <span class="logo">
              <img class="light-logo white" :class="{ 'displayLogo': !isMenuToggle }" src="/guestdocumentation/costsaver/img/logo.png" alt="Logo">
              <img class="light-logo blue" :class="{ 'displayLogo': isMenuToggle }" src="/guestdocumentation/costsaver/img/logo-blue.png" alt="Logo">
            </span>
          </a>
        </div>
      </div>

      <div class="all-menu-wrapper" id="navbarMenu" :class="{ 'menu-visible': isMenuToggle }">
        <nav class="navbar-mainmenu">
          <div class="overlaymdwhite" @click="toggleMenu"></div>
          <div class="mainmenu-content">
            <ul class="navbar-nav">
              <li class="nav-item active">
                <a class="nav-link" href="#home" :class="{ 'menu-visible': isMenuToggle }" @click.prevent="menuScrollTo('home')">Home
                  <span class="sr-only">(current)</span>
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#introduction" :class="{ 'menu-visible': isMenuToggle }" @click.prevent="menuScrollTo('introduction')">Introduction</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#itinerary" :class="{ 'menu-visible': isMenuToggle }" @click.prevent="menuScrollTo('itinerary')">Your Travel Itinerary</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#map" :class="{ 'menu-visible': isMenuToggle }" @click.prevent="menuScrollTo('map')">Map</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#hotel" :class="{ 'menu-visible': isMenuToggle }" @click.prevent="menuScrollTo('hotel')">Hotel List</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#experiences" :class="{ 'menu-visible': isMenuToggle }" @click.prevent="menuScrollTo('experiences')">Optional Experiences</a>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </header>
    <!-- END OF site header Menu-->
    <!-- BEGIN OF page main content -->
    <main class="scrollWeblink page-main main-anim scrollpage-container animated fadeIn" id="mainpage">
      <div
        class="background-home section section-home fullscreen-md main-home section-center content-black bg-level-1"
        data-section="home"
        id="home" :style="[firstOpporunityBackgroundImage != ''
                  ? {
                    backgroundImage: `url('${getParsedImageUrl(
                      firstOpporunityBackgroundImage
                    )}')`
                  } : {'background-image': 'url(/guestdocumentation/costsaver/img/bg-style-1.jpg)'}]">
        <div class="section-wrapper">
          <div class="section-content anim">
            <div class="row">
              <div class="col-12 col-md-12 text-left">
                <div class="cover-header-description">

                  <div class="cover-slider-description">
                    <h1 class="cover-header-description-title1">
                      <i class="icon fa fa-calendar"></i>
                      <span v-if="d && d.itineraries">{{ d.itineraries.fromitinerary | custom-date }}</span>
                      <i class="fa fa-arrow-right ml-2"></i>
                      <i class="icon fa fa-calendar"></i>
                      <span v-if="d && d.itineraries">{{ d.itineraries.toitinerary | custom-date }}</span>
                      <i v-if="Array.isArray(d.itineraries.locations_visited) == true" class="fa fa-map-marker ml-2"></i>
                      <span v-if="d && d.itineraries && d.itineraries.locations_visited && Array.isArray(d.itineraries.locations_visited)">{{ d.itineraries.locations_visited | custom-join('name') }}</span>
                    </h1>
                    <div class="cover-header-description-title2" >
                      TRIP INFORMATION
                    </div>
                    <div class="cover-header-description-title3" v-if="d && d.itineraries">
                        <span>{{ d.itineraries.titleitinerary }}</span>
                    </div>
                    <div class="cover-header-description-title4 txt-uppercase" v-if="d && d.properties_opportunity && d.reference_number">
                      {{ d.reference_number }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Begin of grid list section -->
      <div class="section letter" data-section="introduction" id="introduction" >
        <div class="section-wrapper yellow letter-host with-margin">
          <div class="row">
            <div class="col-12 col-md-12 text-left ">
              <!-- title and description -->
              <div
                class="title-desc anim-4 paddig-container letter-box">
                <button class="button_print" @click="printPage"><i class="fa fa-print"></i>Print</button>
                  <!--PRINT: INTRODUCTION-->
                   <table id="print-header" class="print-only">
                      <tbody>
                         <tr>
                            <td width="70%">
                               <h1 class="title_trip_info">TRIP<br> INFORMATION</h1>
                            </td>
                            <td width="10%"></td>
                            <td class="total-value" width="20%">
                               <div id="logo" class="logo_print">
                                <img class="light-logo displayLogo" src="/guestdocumentation/costsaver/img/logo-blue.png" alt="Logo" width="270">
                               </div>
                            </td>
                         </tr>
                         <tr>
                            <td width="70%" v-if="d && d.itineraries">
                              <div class="border-trip-name">
                               <h4>{{ d.itineraries.titleitinerary }}</h4>
                              </div>
                            </td>
                            <td width="10%"></td>
                            <td class="trip-code-section" width="20%">
                              <div class="print_info_it">
                                <p id="trip-code-number-section" v-if="d && d.properties_opportunity && d.reference_number">TRIP CODE<strong id="trip-code">{{ d.reference_number }}</strong></p>
                                <p id="trip-date-section" v-if="d && d.itineraries">TRIP DATE<strong id="trip-code">{{ d.itineraries.fromitinerary | custom-date }}</strong></p>
                               </div>
                            </td>
                         </tr>
                      </tbody>
                   </table>
                 <!--PRINT: INTRODUCTION-->
                <div v-html="d.guest_documentation.introduction"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- End of grid list section -->

      <!-- Begin of grid list section -->
      <div class="section section-itinerary" data-section="itinerary" id="itinerary" >
        <div class="section-wrapper">
          <div class="section-content anim">

            <div class="col-12 col-lg-12 anim top_blue cover-header-description-title2 blue">
              <div class="title-desc no-print">
                <h2 class="h2 travel-it-title">Your Travel Itinerary</h2>
              </div>
              <div class="title-print"><h1 class="display-5 anim-2 h2 mb-4">Your Travel Itinerary</h1></div>
              <!--PRINT: YOUR TRAVEL ITINERARY-->
              <ul id="days-box" class="print-only print__itinerary">
                <li :id="`day${index}`" v-for="(day, index) in d.itineraries.days" :key="index" class="print__itinerary--item">
                  <h4 class="title-day-date">DAY {{ index + 1}} <span class="title-day" v-html="day.title"></span></h4>
                  <p class="dl-print">
                    <span v-if="day" class="date">{{ day.startdate | custom-date }}</span> / <span class="location"
                      v-if="day && day.locations && Array.isArray(day.locations)"> <span>{{ day.locations | custom-join('name')
                        }}</span>
                    </span>
                  </p>
                  <p v-if="day && day.textday && day.textday[0] && day.textday[0].textday" v-html="day.textday[0].textday"></p>
                  <p v-if="day.meals">
                    <strong class="mr-1">MEAL(S):</strong>
                    <span>{{ day.meals | custom-join('mealsday') }}</span>
                  </p>
                  <p v-if="day.accommodation">
                    <strong class="mr-1">ACCOMMODATION:</strong>
                    <span>{{ day.accommodation}}</span>
                  </p>
                </li>
              </ul>
              <!--PRINT: YOUR TRAVEL ITINERARY-->
            </div>

            <div class="row row-random grid-media-aside-text fade-3 no-print">
                <div
                class="border-card"
                :class="{'col-md-6' : index != Object.keys(d.itineraries.days).length - 1 ||index === Object.keys(d.itineraries.days).length - 1 && Object.keys(d.itineraries.days).length % 2 === 0,
                'col-md-12' : index === Object.keys(d.itineraries.days).length - 1 && Object.keys(d.itineraries.days).length % 2 !== 0}"
                v-for="(day, index) in d.itineraries.days"
                :key="index" @click="dayScrollTo(index)">
                  <div class="card gallery-day" data-toggle="modal" data-target="#modal-fullscreen">
                    <img v-if="day.url_image_1200_725" :src="day.url_image_1200_725"/>
                    <img v-if="!day.url_image_1200_725" src="/guestdocumentation/costsaver/img/day-img.jpg"/>
                    <div class="info">
                      <div class="text-inside">
                        <h1>DAY {{ day.startday }}</h1>
                        <p class="subtitle" v-html="day.title"></p>
                        <p class="date">
                          <i class="icon fa fa-calendar mr-2"></i>
                          <span class="text-uppercase" v-if="day">{{ day.startdate | custom-date }}</span>
                        </p>
                        <p v-if="day && day.locations && Array.isArray(day.locations)" class="location mt-2">
                          <i class="fa fa-map-marker mr-2"></i>
                          <span >{{ day.locations | custom-join('name') }}</span>
                        </p>
                        <p v-if="day && day.textday && day.textday[0] && day.textday[0].textday">
                          <span v-html="day.textday[0].textday.substring(0,265)+'...'"></span>
                          <span href='#' data-toggle='modal' class='underlineLink'> Show more</span>
                        </p>
                        <p v-if="day.meals">
                          <strong class="mr-1">MEAL(S):</strong>
                          <span>{{ day.meals | custom-join('mealsday') }}</span>
                        </p>
                        <p v-if="day.accommodation">
                          <strong class="mr-1">HOTEL:</strong>
                          <span>{{ day.accommodation}}</span>
                        </p>

                      </div>
                    </div>
                  </div>
                </div>

            </div>
          </div>
        </div>
      </div>
      <!-- BEGIN MAP -->
      <div class="section content-white bg-level-2 bg-mark no-print" data-section="map" id="map" >
        <img v-if="secondOpporunityBackgroundImage != '' " :src="`${getParsedImageUrl(secondOpporunityBackgroundImage)}`" alt="">
        <img v-else src="/guestdocumentation/costsaver/img/bg-style-1.jpg">
        <div class="section-wrapper with-margin">
          <div class="section-content anim paddig-container">
            <div class="row">
              <div class="col-12 col-md-12 text-left">
                <div class="title-desc no-print">
                  <h2 class="h2 anim-2">Map</h2>
                  <p class="mb-5 mt-3 text-center">
                    Map route is to be used as a guide for illustration purposes
                    only, and does not represent the exact path taken.
                  </p>
                </div>
                  <div class="title-print"><h1 class="display-5 anim-2 h2 mb-4">Map</h1></div></div>
                  <div class="col-12 col-md-12">
                <div class="section-maps">
                  <Map :locations="locationsVisited" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- END MAP -->
      <!-- BEGIN HOTEL LIST -->
      <div class="section fullscreen-md-off no-footer bg-level-4 "
        data-section="hotel" id="hotel">
        <div class="section-wrapper yellow2 blue2 with-margin section-hotel">
          <div class="section-content anim paddig-container">
            <div class="title-desc no-print">
              <h2 class="h2 blue">Hotel List</h2>
            </div>
            <div class="title-print"><h1 class="display-5 anim-2 h2 mb-4">Hotel List</h1></div>
            <div class="row">
              <div class="col-12 col-md-12  text-left">
                  <div class="section-info white pr-4">
                    <div class="section-column">
                      <div v-html="d.guest_documentation.hotel_list"></div>
                    </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- END HOTEL LIST -->
      <!-- BEGIN OPTIONAL EXPERIENCES -->
      <div class="section bg-level-2  bg-mark " data-section="experiences" id="experiences" v-if="!isInvalidContent(d.guest_documentation.optional_experience)">
        <img v-if="thirdOpporunityBackgroundImage != '' " :src="`${getParsedImageUrl(thirdOpporunityBackgroundImage)}`" alt="">
        <img v-else src="/guestdocumentation/costsaver/img/blank.png" alt="">
        <div class="section-wrapper with-margin">
            <div class="section-content paddig-container">
              <div class="row">
                <div class="col-12 col-md-12 anim">
                  <div class="title-desc">
                    <h2 class="display-5 anim-2 text-center h2 no-print">Optional Experiences</h2>
                    <div class="title-print"><h1 class="display-5 anim-2 h2 mb-4">Optional Experiences</h1></div>
                    <div class="section-info white">
                      <div v-html="d.guest_documentation.optional_experience"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- END OPTIONAL EXPERIENCES -->
      <footer >
        <div class="section-wrapper padding-footer ">
          <div class="powered-by-text">
            Powered by<br>
            <img src="/guestdocumentation/costsaver/img/logo-itp.png" width="80">
          </div>
           <div class="detail">All rights reserved: ©Global Encounters™ 1999 - {{new Date().getFullYear()}}</div>
        </div>
      </footer>
    </main>
    <!-- Modal Fullscreen -- DAYS-->
    <div
      class="modal  modal-fullscreen fade modalDays"
      id="modal-fullscreen" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
      :class="{ 'show': isModalToggle }"
      :style="{ display: 'block', paddingRight: '16px' }"
      v-show="isModalToggle">
      <div class="overlaymd" @click="toggleModal"></div>
      <div class="section-header">
        <i class="fa fa-chevron-left" @click="toggleModal"></i>
        <button
          type="button" class="close" data-dismiss="modal" aria-hidden="true"
          @click="toggleModal"><i class="fa fa-times"></i></button>
      </div>
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body mt-5">

            <div
              class="col-md-12 p-0 section-day p active"
              :id="`day${index}`"
              v-for="(day, index) in d.itineraries.days" :key="index">
              <div class="row">
                <div class="col-md-12 cover-image section-text">
                  <img v-if="day.url_image_1600_900" :src="day.url_image_1600_900"/>
                  <img v-if="!day.url_image_1600_900" src="/guestdocumentation/costsaver/img/day-img.jpg"/>
                  <div class="section_text_overlay">
                    <h1>DAY {{ index + 1}}</h1>
                    <p class="subtitle" v-html="day.title"></p>
                  </div>
                </div>
                <div class="col-md-12 section-text">
                  <div class="align-vcenter">
                    <p class="date">
                      <i class="icon fa fa-calendar mr-1"></i>
                      <span class="text-uppercase" v-if="day">{{ day.startdate | custom-date }}</span>
                    </p>
                    <p v-if="day && day.locations && Array.isArray(day.locations)" class="location mt-2">
                      <i class="fa fa-map-marker mr-2"></i>
                      <span >{{ day.locations | custom-join('name') }}</span>
                    </p>
                    <p v-if="day && day.textday && day.textday[0] && day.textday[0].textday" v-html="day.textday[0].textday"></p>
                    <p v-if="day.meals">
                      <strong class="mr-1">MEAL(S):</strong>
                      <span>{{ day.meals | custom-join('mealsday') }}</span>
                    </p>
                    <p v-if="day.accommodation">
                      <strong class="mr-1">HOTEL:</strong>
                      <span>{{ day.accommodation}}</span>
                    </p>
                  </div>
                  <footer class="section-footer scrolldownDay nextday" >
                    <a class="down" href="#section02">
                      <span class="txt">DAY {{ Number(day.startday) + 1 }}</span>
                    </a>
                  </footer>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>
